import classnames from 'classnames';
import { PropsWithChildren } from 'react';

import style from './index.module.css';

interface Props {
  noBottomMargin?: boolean;
}

/**
 * Component that can be used with HeroPage to show additional menu content when the screen width becomes too small to
 * show the <HeroMenu/> component.
 *
 * @param children the content.
 * @param noBottomMargin option to remove the default bottom padding provided by the component.
 */
export function HeroContentMenu({ children, noBottomMargin = false }: PropsWithChildren<Props>) {
  return (
    <div
      className={classnames({
        [style['Content']!]: true,
        [style['BottomMargin']!]: !noBottomMargin,
      })}
    >
      {children}
    </div>
  );
}
